import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["primaryPreview", "primaryInput", "imagesPreview", "imagesInput"]

  connect() {
    this.setupFileValidation()
  }

  setupFileValidation() {
    const maxFileSize = 5 * 1024 * 1024 // 5MB
    const allowedTypes = ['image/png', 'image/jpg', 'image/jpeg']

    ;[this.primaryInputTarget, this.imagesInputTarget].forEach(input => {
      input.addEventListener('change', (event) => {
        const files = Array.from(event.target.files)
        const invalidFiles = files.filter(file => {
          const isValidType = allowedTypes.includes(file.type)
          const isValidSize = file.size <= maxFileSize
          return !isValidType || !isValidSize
        })

        if (invalidFiles.length > 0) {
          event.target.value = '' // Clear selection
          const message = invalidFiles.map(file => {
            if (!allowedTypes.includes(file.type)) {
              return `${file.name} must be a PNG or JPEG file`
            }
            return `${file.name} must be less than 5MB`
          }).join('\n')
          alert(message)
          return
        }

        this.previewFiles(event.target)
      })
    })
  }

  previewFiles(input) {
    const files = Array.from(input.files)
    const previewTarget = input === this.primaryInputTarget ? 
      this.primaryPreviewTarget : 
      this.imagesPreviewTarget

    // Clear existing previews
    previewTarget.innerHTML = ''

    files.forEach(file => {
      const reader = new FileReader()
      reader.onload = (e) => {
        const preview = document.createElement('div')
        preview.className = 'relative group'
        preview.innerHTML = `
          <img src="${e.target.result}" class="h-24 w-24 object-cover rounded-lg" />
          <div class="absolute inset-0 bg-black bg-opacity-50 group-hover:opacity-100 opacity-0 transition-opacity rounded-lg flex items-center justify-center">
            <button type="button" class="text-white" data-action="click->rental-images#removeFile">
              <svg class="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
              </svg>
            </button>
          </div>
        `
        previewTarget.appendChild(preview)
      }
      reader.readAsDataURL(file)
    })
  }

  removeFile(event) {
    const preview = event.target.closest('.relative')
    const previewContainer = preview.parentElement
    const input = previewContainer === this.primaryPreviewTarget ? 
      this.primaryInputTarget : 
      this.imagesInputTarget

    preview.remove()
    input.value = '' // Clear the file input
  }
}
